<!-- <footer class="footer">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul>
                <li>
                    <a href="/">
                        Home
                    </a>
                </li>
               
            </ul>
        </nav>
        <p class="copyright pull-right">
            &copy;
            <script>
                document.write(new Date().getFullYear())
            </script>
            <a href="http://www.arrivae.com">Arrivae</a>, all rights reserved
        </p>
    </div>
</footer> -->
<!-- <div class="footer mt-5">
    <div class="container">
      <div class="row py-5">
        <div class="col-sm-2">
          <ul>
            <li>Home</li>
            <li>Looks</li>
            <li>Home Interiors</li>
            <li>Office Interiors</li>
          </ul>
        </div>
        <div class="col-sm-2">
          <ul>
            <li>Design Consulation</li>
            <li>How it works?</li>
            <li>Become a design partner</li>
            <li>Sign in/ Sign up</li>
          </ul>
        </div>
        <div class="col-sm-2 pr-2">
          <ul>
            <li><i class="fa fa-map-marker" aria-hidden="true"></i> xxxxx xxxx xxxxx xxx xxxxxx xxx xxxx xxxxx</li>
            <li class="mt-3"><i class="fa fa-envelope" aria-hidden="true"></i> example@xyz.com</li>
          </ul>
        </div>
        <div class="col-sm-3 mobile_col">
          <ul>
            <li><i class="fa fa-phone" aria-hidden="true"></i> +91 8376452345</li>
            <li class="pl-3">+91 8376452345</li>
          </ul>
        </div>
        <div class="col-sm-3">
          <ul>
            <li>Copyright©2017.Term & Conditions</li>
            <li class="mt-3">Folow Us</li>
            <li>
              <i class="fa fa-facebook mr-3" aria-hidden="true"></i>
              <i class="fa fa-twitter mr-3" aria-hidden="true"></i>
              <i class="fa fa-instagram mr-3" aria-hidden="true"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->

<div class="container-fluid">
  <div class="row justify-content-end">
    <div class="col-12 col-lg-10">
    <!--   <div class="col-12">
        <a href="https://www.facebook.com/Arrivae-1947981418749602/" target="_blank"><i class="fa fa-facebook fa_icon_marg" aria-hidden="true"></i></a>
        <a href="https://www.linkedin.com/company/13439634/" target="_blank"><i class="fa fa-linkedin fa_icon_marg" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/arrivae/" target="_blank"><i class="fa fa-instagram fa_icon_marg" aria-hidden="true"></i></a> -->
        <!-- <a href="https://www.houzz.in/pro/arrivae" target="_blank"><i class="fa fa-houzz fa_icon_marg" aria-hidden="true"></i></a> -->
    <!--     <a href="https://twitter.com/Arrivae1" target="_blank"><i class="fa fa-twitter fa_icon_marg" aria-hidden="true"></i></a>
        <a href="https://in.pinterest.com/arrivae1/" target="_blank"><i class="fa fa-pinterest-p fa_icon_marg" aria-hidden="true"></i></a> -->
        <!-- <a href="http://arrivae.business.site/" target="_blank"><i class="fa fa-google-plus fa_icon_marg" aria-hidden="true"></i></a> -->
    <!--   </div> -->
      <div class="footer">
        <p>All Rights Reserved &copy; 2017 | Arrivae</p>
      </div>
    </div>
  </div>
</div>













// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.html